<template>
  <div class="bj pt22">
    <div class="container evaluate-container">
      <div class="breadcrumb-wrapper">
        <router-link to="/">首页</router-link>>
        <span>化肥</span> >
        <span>心连心氮肥 5KG/袋</span> >
        <span>商品评价</span>
      </div>
      <div class="statistics">
        <router-link to="/detail" class="sku">
          <h1 style="font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑';">心连心氮肥&nbsp; 5KG/袋</h1>
          <p>适合种黄瓜玉米番茄</p>
        </router-link>
        <div class="numbers">
          <dl>
            <dt style="font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑';">9999</dt>
            <dd>人已购买</dd>
          </dl>
           <dl>
            <dt style="font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑';">98.3%</dt>
            <dd>好评率</dd>
          </dl>
        </div>
      </div>
      <h1 class="title">热门评价</h1>
      <div class="evaluate-items">
        <div class="evaluate-item">
          <div class="t">
           <div>
              <div class="cover">
                <img src="./images/cover.jpg"/>
              </div>
              <div class="name">
                Windir
              </div>
           </div>
           <div class="sku-rate">
             <v-rate />
           </div>
          </div>
          <div class="text">
            <p>其实衣服是不错的，见到同事穿才买，原来买小换大一个码数，回来折腾好几天，心灰意冷，袖子那里是其他人穿过一样有送菜的污垢，懒得再换再折腾，希望以后人家退回来的货要细心检查......</p>
          </div>
           <ul class="image">
              <li><img src="./images/u1212.jpg"/></li>
              <li><img src="./images/u1212.jpg"/></li>
              <li><img src="./images/u1212.jpg"/></li>
              <li><img src="./images/u1212.jpg"/></li>
              <li><img src="./images/u1212.jpg"/></li>
              <li><img src="./images/u1212.jpg"/></li>
              <li><img src="./images/u1212.jpg"/></li>
              <li><img src="./images/u1212.jpg"/></li>
            </ul>
            <div class="f">
              <span class="date">1周前</span>
              <v-thumbs-up />
            </div>
        </div>
         <div class="evaluate-item">
          <div class="t">
           <div>
              <div class="cover">
                <img src="./images/cover.jpg"/>
              </div>
              <div class="name">
                Windir
              </div>
           </div>
           <div class="sku-rate">
             <v-rate />
           </div>
          </div>
          <div class="text">
            <p>其实衣服是不错的，见到同事穿才买，原来买小换大一个码数，回来折腾好几天，心灰意冷，袖子那里是其他人穿过一样有送菜的污垢，懒得再换再折腾，希望以后人家退回来的货要细心检查......</p>
          </div>
           <ul class="image">
              <li><img src="./images/u1212.jpg"/></li>
              <li><img src="./images/u1212.jpg"/></li>
              <li><img src="./images/u1212.jpg"/></li>
              <li><img src="./images/u1212.jpg"/></li>
              <li><img src="./images/u1212.jpg"/></li>
              <li><img src="./images/u1212.jpg"/></li>
              <li><img src="./images/u1212.jpg"/></li>
              <li><img src="./images/u1212.jpg"/></li>
            </ul>
            <div class="f">
              <span class="date">1周前</span>
              <v-thumbs-up />
            </div>
        </div>
         <div class="evaluate-item">
          <div class="t">
           <div>
              <div class="cover">
                <img src="./images/cover.jpg"/>
              </div>
              <div class="name">
                Windir
              </div>
           </div>
           <div class="sku-rate">
             <v-rate />
           </div>
          </div>
          <div class="text">
            <p>其实衣服是不错的，见到同事穿才买，原来买小换大一个码数，回来折腾好几天，心灰意冷，袖子那里是其他人穿过一样有送菜的污垢，懒得再换再折腾，希望以后人家退回来的货要细心检查......</p>
          </div>
           <ul class="image">
              <li><img src="./images/u1212.jpg"/></li>
              <li><img src="./images/u1212.jpg"/></li>
              <li><img src="./images/u1212.jpg"/></li>
              <li><img src="./images/u1212.jpg"/></li>
              <li><img src="./images/u1212.jpg"/></li>
              <li><img src="./images/u1212.jpg"/></li>
              <li><img src="./images/u1212.jpg"/></li>
              <li><img src="./images/u1212.jpg"/></li>
            </ul>
            <div class="f">
              <span class="date">1周前</span>
              <v-thumbs-up />
            </div>
        </div>
         <div class="evaluate-item">
          <div class="t">
           <div>
              <div class="cover">
                <img src="./images/cover.jpg"/>
              </div>
              <div class="name">
                Windir
              </div>
           </div>
           <div class="sku-rate">
             <v-rate />
           </div>
          </div>
          <div class="text">
            <p>其实衣服是不错的，见到同事穿才买，原来买小换大一个码数，回来折腾好几天，心灰意冷，袖子那里是其他人穿过一样有送菜的污垢，懒得再换再折腾，希望以后人家退回来的货要细心检查......</p>
          </div>
           <ul class="image">
              <li><img src="./images/u1212.jpg"/></li>
              <li><img src="./images/u1212.jpg"/></li>
              <li><img src="./images/u1212.jpg"/></li>
              <li><img src="./images/u1212.jpg"/></li>
              <li><img src="./images/u1212.jpg"/></li>
              <li><img src="./images/u1212.jpg"/></li>
              <li><img src="./images/u1212.jpg"/></li>
              <li><img src="./images/u1212.jpg"/></li>
            </ul>
            <div class="f">
              <span class="date">1周前</span>
              <v-thumbs-up />
            </div>
        </div>
      </div>
      <div class="reload-more">
        加载更多
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      rate: 4,
      iconClasses: ['fa fa-heart', 'fa fa-heart', 'fa fa-heart','fa fa-heart','fa fa-heart']
    }
  }
};
</script>

<style lang="scss">
.evaluate-container {
  .statistics {
    padding-top: 30px;
    border: 1px #e4e4e4 solid;
    background: #fff;
    height: 138px;
    box-sizing: border-box;
    .sku {
      float: left;
      padding-left: 76px;
      border-right: 1px #f2f2f2 solid;
      width: 218px;
      height: 80px;
      cursor: pointer;
      h1 {
        font-size: 18px;
        font-weight: 700;
        padding: 5px 0 11px;
      }
      p {
        padding-left: 9px;
        font-size: 16px;
        color: #999999;
      }
    }
    .numbers{
      float: left;
      dl{
        display: inline-block;
        padding-left: 98px;
        padding-right:2px;
        dt{
          font-weight: 700;
          color: #F04844;
          line-height: 36px;
          font-size: 28px;
        }
        dd{
          padding-top: 3px;
          font-size: 14px;
          text-align: center;
          color: #999999;
        }
      }
    }
  }
  .title{
    padding-top: 18px;
    height: 52px;
    font-size: 18px;
    box-sizing: border-box;
  }
  .evaluate-items{
    .evaluate-item{
      margin-bottom: 10px;
      padding: 26px 100px 0 37px;
      background: #fff;
      border:1px #e4e4e4 solid;
      .t{
        display: flex;
        justify-content: space-between;
        height: 56px;
        .cover{
          float: left;
          img{
            width:49px;
            height: 49px;
            border-radius: 50%;
            overflow: hidden;
          }
        }
        .name{
          float: left;
          padding:7px 0 0 13px;
          font-size: 14px;
        }
        .sku-rate{
          padding-top: 20px;
        }
      }
      .text{
        padding-left: 62px;
        p{
          color: #999999;
          font-size: 14px;
          line-height: 24px;
        }
      }
      .image{
        padding:14px 0 0 62px;
        width: 650px;
        overflow: hidden;
        li{
          margin:0 21px 10px 0;
          float:left;
          img{
            display: block;
            width: 140px;
            height: 140px;
          }
        }
      }
      .f{
        margin:9px 0 0 62px;
        display: flex;
        justify-content: space-between;
        border-top: 1px #f2f2f2 solid;
        height: 62px;
        .date{
          padding-top: 13px;
          font-size: 12px;
          color: #999999;
        }
      }
    }
  }
  .reload-more{
    margin: 25px 0 30px;
    height: 58px;
    line-height: 58px;
    text-align: center;
    border:1px #e4e4e4 solid;
    background: #fff;
    color: #F04844;
    font-size: 14px;
    cursor: pointer;
  }
}
</style>
